module.exports = __webpack_public_path__ + "static/midground-31f833c75f954d199d476f33a8c820db.png";